import React, { useState } from 'react'
import './styles/story.css'
import Carousel from './StoryCarousel2'

import Eighteen from './story/2018'
import Nineteen from './story/2019'
import Twenty from './story/2020'
import Twentyone from './story/2121'
import Twentytwo from './story/2022'

import Twentythree from './story/2023'
import Twentyfour from './story/2024'
import Twentyfive from './story/2025'
import Twentysix from './story/2026'

export default function OurStory() {
  const [currentSlide, setCurrentSlide] = useState(0)

  return (
    <section id="story" aria-labelledby="story-title">
      <div className="story-shell">

        <header className="story-intro">
          <div className="story-eyebrow">
            <span /> THE TUBBEES TIMELINE
          </div>

          <h1 id="story-title">
            Our <em>story.</em>
          </h1>

          <p>
            From one Glasgow store to a whole lot of flavour,
            these are the moments that made Tubbees what it is today.
          </p>
        </header>


        {/* TIMELINE */}
        <div className="story-timeline" aria-hidden="true">

          <span className={currentSlide === 0 ? 'active' : ''}>
            2026
          </span>

          <i />

          <span className={currentSlide === 1 ? 'active' : ''}>
            2025
          </span>

          <i />

          <span className={currentSlide === 2 ? 'active' : ''}>
            2024
          </span>

          <i />

          <span className={currentSlide === 3 ? 'active' : ''}>
            2023
          </span>

          <i />

          <span className={currentSlide === 4 ? 'active' : ''}>
            2022
          </span>

          <i />

          <span className={currentSlide === 5 ? 'active' : ''}>
            2021
          </span>

          <i />

          <span className={currentSlide === 6 ? 'active' : ''}>
            2020
          </span>

          <i />

          <span className={currentSlide === 7 ? 'active' : ''}>
            2019
          </span>

          <i />

          <span className={currentSlide === 8 ? 'active' : ''}>
            2018
          </span>

        </div>


        {/* CAROUSEL */}
        <div className="story-carousel-frame">

          <Carousel
            show={2}
            onSlideChange={setCurrentSlide}
          >

            {/* 2026 - LATEST */}
            <div>
              <Twentysix />
            </div>

            {/* 2025 */}
            <div>
              <Twentyfive />
            </div>

            {/* 2024 */}
            <div>
              <Twentyfour />
            </div>

            {/* 2023 */}
            <div>
              <Twentythree />
            </div>

            {/* 2022 */}
            <div>
              <Twentytwo />
            </div>

            {/* 2021 */}
            <div>
              <Twentyone />
            </div>

            {/* 2020 */}
            <div>
              <Twenty />
            </div>

            {/* 2019 */}
            <div>
              <Nineteen />
            </div>

            {/* 2018 */}
            <div>
              <Eighteen />
            </div>

          </Carousel>

        </div>


        <div className="story-signoff">
          <span />
          KEEP THE GOOD TIMES POURING
          <span />
        </div>

      </div>
    </section>
  )
}